import FastMarquee from "react-fast-marquee";
import { PawPrint } from "lucide-react";

const ITEMS = ["Dog Boarding", "Dog Walking", "Dog Sitting", "Doggie Daycare", "House Visits"];

export default function Marquee() {
  return (
    <div className="py-6 bg-primary" data-testid="marquee">
      <FastMarquee speed={38} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <div key={i} className="flex items-center gap-8 px-8">
            <span className="font-display font-extrabold text-3xl sm:text-5xl text-primary-foreground">
              {item}
            </span>
            <PawPrint className="text-secondary" size={28} />
          </div>
        ))}
      </FastMarquee>
    </div>
  );
}
